import React, { useState } from 'react'
import { CircularProgress, IconButton, Tooltip } from '@mui/material'
import GetAppIcon from '@mui/icons-material/GetApp'

import { get } from 'services/api'
import Colors from 'utils/Colors'
import { downloadBlob } from 'utils/downloadFile'
import { useSelector } from 'react-redux'
import Button from '@mui/material/Button'
import styles from '../styles'

const DownloadAppButton = ({
  applicationUUID,
  useTitle = false,
}) => {
  const [fileLoading, setFileLoading] = useState({})

  const token = useSelector((state) => state.auth.access_token)

  const classes = styles()

  const handleFileDownload = async (id) => {
    setFileLoading((currentLoading) => ({ ...currentLoading, [id]: true }))

    try {
      const res = await get({
        url: `/application/pdf-report/file?application_uuid=${id}`,
        token,
        responseType: 'blob',
        accept: 'application/pdf',
      })

      if (res) {
        const pdf = res instanceof Blob ? res : new Blob([res], { type: 'application/pdf' })
        downloadBlob(pdf, `application-${id}.pdf`)
      }
    } finally {
      setFileLoading((currentLoading) => ({ ...currentLoading, [id]: false }))
    }
  }

  const renderIconButton = () =>
      <IconButton
        className={classes.iconButton}
        onClick={() => handleFileDownload(applicationUUID)}
        size="large"
      >
        <GetAppIcon style={{ color: Colors.primaryColor, fontSize: 20 }} />
      </IconButton>
    

  const renderLabeledButton = () => (
    <Button
      size="small"
      variant="outlined"
      onClick={() => handleFileDownload(applicationUUID)}
      startIcon={
        fileLoading[applicationUUID] ? (
          <CircularProgress size={18} color="primary" />
        ) : (
          <GetAppIcon style={{ color: Colors.primaryColor, fontSize: 20 }} />
        )
      }
    >
      Baixar PDF
    </Button>
  )

  return !useTitle && fileLoading[applicationUUID] ? (
    <CircularProgress size={18} color="primary" />
  ) : (
    <Tooltip
      arrow
      placement="top"
      title={<b className={classes.tooltipText}>Baixar o relatório da aplicação</b>}
    >
      {useTitle ? renderLabeledButton() : renderIconButton()}
    </Tooltip>
  )
}

export default DownloadAppButton
